const INDUSTRIES = [
  {
    title: "Technology & Startups",
    description:
      "Protect your innovative brand, app name, or software product with federal trademark registration. In the fast-moving tech industry, securing your intellectual property early is essential to prevent competitors from capitalizing on your brand recognition and reputation.",
    image:
      "https://images.unsplash.com/photo-1573235781593-0094b20e59d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHx0ZWNoJTIwY2FmZSUyMGNvZGluZ3xlbnwwfHx8fDE3NzYxOTI4Nzd8MA&ixlib=rb-4.1.0&q=85",
    alt: "Technology startup workspace representing trademark protection for tech brands",
  },
  {
    title: "Retail & E-Commerce",
    description:
      "Safeguard your product names, store brand, and private labels against counterfeiters and copycats. Trademark registration is a prerequisite for Amazon Brand Registry and helps establish consumer trust across all online and offline retail channels.",
    image:
      "https://images.pexels.com/photos/9973170/pexels-photo-9973170.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Retail brand signage representing trademark protection for e-commerce businesses",
  },
  {
    title: "Corporate & Finance",
    description:
      "Establish and protect your corporate identity, financial product names, and service marks. In the highly regulated financial services industry, a registered trademark adds credibility, protects client trust, and serves as a valuable intangible asset on your balance sheet.",
    image:
      "https://images.unsplash.com/photo-1762439183787-54302c4dfb9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBnbGFzcyUyMGJ1aWxkaW5nJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc2MTkyODcyfDA&ixlib=rb-4.1.0&q=85",
    alt: "Modern corporate building representing trademark protection for financial institutions",
  },
  {
    title: "Creative & Design Agencies",
    description:
      "Protect your agency name, creative methodologies, proprietary tools, and client-facing brands. In the creative industry, your brand identity is your calling card. Trademark registration ensures your unique creative identity remains exclusively yours and cannot be appropriated by competitors.",
    image:
      "https://images.unsplash.com/photo-1758873272412-7166447a94ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxjcmVhdGl2ZSUyMHN0YXJ0dXAlMjBvZmZpY2V8ZW58MHx8fHwxNzc2MTkyODc3fDA&ixlib=rb-4.1.0&q=85",
    alt: "Creative professionals collaborating representing trademark protection for design agencies",
  },
  {
    title: "Healthcare & Wellness",
    description:
      "Secure your healthcare practice name, wellness product brand, and supplement line with federal trademark protection. In an industry built on trust and patient confidence, a registered trademark establishes authority and prevents unauthorized use of your healthcare brand identity.",
  },
  {
    title: "Food & Beverage",
    description:
      "Protect your restaurant name, food product brand, recipe concepts, and beverage labels. The food and beverage industry is intensely competitive, and trademark registration helps you stand out, prevent imitation, and build a loyal customer base that recognizes and trusts your brand.",
  },
  {
    title: "Entertainment & Media",
    description:
      "Safeguard your show names, podcast brands, content series titles, and production company identity. In the rapidly evolving media landscape, a registered trademark protects your creative properties and ensures your audience always knows the authentic source of the content they love.",
  },
  {
    title: "Real Estate & Construction",
    description:
      "Protect your real estate brand, property development names, and construction company identity. As your business grows across states, a federally registered trademark ensures consistent brand protection and prevents competitors from capitalizing on the reputation you have built.",
  },
];

export default function IndustriesSection() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A8A] mb-4">
            Industries We Serve
          </span>
          <h2
            data-testid="industries-heading"
            className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0F172A] tracking-tight mb-4"
          >
            Trademark Registration for Every Industry
          </h2>
          <p className="text-[#475569] text-base sm:text-lg max-w-3xl mx-auto leading-relaxed">
            We serve businesses across all sectors and industries. No matter what field you operate in, trademark registration is essential for protecting your brand identity, building consumer trust, and establishing a strong foundation for business growth in the United States market.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {INDUSTRIES.map((industry, i) => (
            <div
              key={industry.title}
              data-testid={`industry-card-${i}`}
              className="group rounded-lg overflow-hidden border border-slate-200 bg-white hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              {industry.image ? (
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={industry.image}
                    alt={industry.alt}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F1A]/80 to-transparent" />
                  <h3 className="absolute bottom-4 left-4 right-4 font-heading text-base font-bold text-white">
                    {industry.title}
                  </h3>
                </div>
              ) : (
                <div className="h-48 bg-gradient-to-br from-[#1E3A8A] to-[#2563EB] flex items-end p-4">
                  <h3 className="font-heading text-base font-bold text-white">
                    {industry.title}
                  </h3>
                </div>
              )}
              <div className="p-5">
                <p className="text-[#475569] text-sm leading-relaxed">{industry.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
